import React from 'react';
import { Path, SVG } from 'web-common/src/shared/design-system/Utilities';

export const Chat: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <SVG width={24} height={24} viewBox='0 0 24 24' {...props}>
    <Path
      // eslint-disable-next-line max-len -- SVG path properties
      d='M3.01 4.00056V4C3.01 3.44575 3.4588 3 4 3H20C20.5477 3 21 3.45228 21 4V16C21 16.5477 20.5477 17 20 17H6H5.58579L5.29289 17.2929L3.00134 19.5844L3.01 4.00056Z'
      fill='none'
      stroke='currentColor'
      strokeWidth={2}
    />
    <Path d='M6 12H14V14H6V12Z' fill='currentColor' />
    <Path d='M6 9H18V11H6V9Z' fill='currentColor' />
    <Path d='M6 6H18V8H6V6Z' fill='currentColor' />
  </SVG>
);

export const ChatBubble: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <SVG width='16' height='14' viewBox='0 0 16 14' fill='none' {...props}>
    <Path
      d='M8.02493 0C3.58392 0 0.0185951 2.9375 0.0185951 6.5C0.0185951 8 0.612816 9.375 1.64488 10.4688C1.20704 11.6875 0.237519 12.75 0.206244 12.75C-0.0126796 12.9688 -0.0439544 13.2812 0.0498699 13.5625C0.174969 13.8438 0.456442 14 0.76919 14C2.67695 14 4.17814 13.2188 5.11638 12.5625C5.99208 12.8438 6.99287 13 8.02493 13C12.4347 13 16 10.0938 16 6.5C16 2.9375 12.4347 0 8.02493 0ZM8.02493 11.5C7.18052 11.5 6.3361 11.375 5.55423 11.125L4.83491 10.9062L4.24069 11.3438C3.80284 11.6562 3.17735 12 2.42675 12.25C2.67695 11.875 2.89587 11.4375 3.05225 11L3.39627 10.125L2.7395 9.4375C2.17655 8.84375 1.51978 7.84375 1.51978 6.5C1.51978 3.75 4.42834 1.5 8.02493 1.5C11.5903 1.5 14.5301 3.75 14.5301 6.5C14.5301 9.28125 11.5903 11.5 8.02493 11.5Z'
      fill='#383838'
    />
  </SVG>
);
